// tracking.interceptor.ts
import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AppConfigService } from '@core/services/config/app-config.service';
import { TrackingService } from '@core/services/config/tracking.service';
import { appConfig } from 'src/app/app.config';

export const trackingInterceptor: HttpInterceptorFn = ( req, next ) => {
    const trackingId = inject( TrackingService ).trackingId;
    
    const appC = inject(AppConfigService);

    if ( req.method === 'POST' && trackingId ) {
        req = req.clone( {
            setHeaders: {
                'x-emp': trackingId,
                'x-emp-page': appC.cli() ? window.location.pathname : '*** FROM SERVER ***'
            }
        });
    }

    return next( req );
};